import { render } from "./providerDashboard.vue?vue&type=template&id=0bf00f92&scoped=true&ts=true"
import script from "./providerDashboard.vue?vue&type=script&lang=ts"
export * from "./providerDashboard.vue?vue&type=script&lang=ts"

import "./providerDashboard.vue?vue&type=style&index=0&id=0bf00f92&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf00f92"]])

export default __exports__